import { HandmadeCreatorLandingPage } from './HandmadeCreatorLandingPage';

export const handmadeCreatorLandingRouter = {
  '/@/handmade': HandmadeCreatorLandingPage,
};
